import { useEffect, type ReactNode } from 'react'

interface DrawerProps {
  title: string
  onClose: () => void
  children: ReactNode
}

/**
 * Right-side slide-over panel. Used for tenant edit and other in-context
 * forms. Full-width on phones (see .admin-drawer mobile rule). Closes on
 * backdrop click and Escape.
 */
export function Drawer({ title, onClose, children }: DrawerProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="admin-drawer-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="admin-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-drawer-head">
          <h3>{title}</h3>
          <button
            type="button"
            className="admin-btn admin-btn-ghost"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}
